import React from 'react'

const EtAdminLeadFlow = () => {
  return (
    <div>EtAdminLeadFlow</div>
  )
}

export default EtAdminLeadFlow